import type { AncillaryOrigin, SelectedAncillary } from '../../api/models/bff/Ancillaries';

/** Shared ancillary definition used by both pricing and selected ancillaries mocks */
export interface MockAncillaryDefinition {
  code: string;
  type: string;
  details: string;
  origin: AncillaryOrigin;
  quantity: number;
  price: { amount: string; currency: string };
  included: boolean;
}

/** Ancillaries included in the subscription plan — no extra cost */
export const MOCK_ANCILLARIES_INCLUDED: MockAncillaryDefinition[] = [
  {
    code: 'VEL-CABINBAG-RT3-DAILY',
    type: 'BAGGAGE',
    details: 'Cabin bag 10kg',
    origin: 'INCLUDED_IN_PLAN',
    quantity: 2,
    price: { amount: '0.00', currency: 'EUR' },
    included: true,
  },
  {
    code: 'VEL-SEAT-RT1-MONTHLY-PLAN',
    type: 'SEAT',
    details: 'Standard seat selection',
    origin: 'INCLUDED_IN_PLAN',
    quantity: 1,
    price: { amount: '0.00', currency: 'EUR' },
    included: true,
  },
];

/** Ancillaries purchased as one-time add-ons */
export const MOCK_ANCILLARIES_PURCHASED: MockAncillaryDefinition[] = [
  {
    code: 'VEL-CABINBAG-RT3-DAILY',
    type: 'BAGGAGE',
    details: 'Cabin bag 10kg',
    origin: 'ONE_TIME_PURCHASE',
    quantity: 1,
    price: { amount: '15.00', currency: 'EUR' },
    included: false,
  },
  {
    code: 'PRIORITY',
    type: 'SPECIAL_SERVICE',
    details: 'Priority boarding',
    origin: 'ONE_TIME_PURCHASE',
    quantity: 1,
    price: { amount: '2.50', currency: 'EUR' },
    included: false,
  },
];

/** Default set — included in plan, used by createMockPricing */
export const MOCK_ANCILLARIES = MOCK_ANCILLARIES_INCLUDED;

/**
 * Convert a set of MockAncillaryDefinition into SelectedAncillary[] format
 *
 * @param ancillaries - The set of ancillaries to convert (defaults to MOCK_ANCILLARIES_INCLUDED)
 * @returns Array of selected ancillaries
 */
export function toSelectedAncillaries(ancillaries: MockAncillaryDefinition[] = MOCK_ANCILLARIES_INCLUDED): SelectedAncillary[] {
  return ancillaries.map(({ code, type, details, origin, quantity, price }) => ({
    code,
    type,
    details,
    origin,
    quantity,
    price,
  }));
}

